import { styled } from '@creditas-ui/system';

const DrawerElement = styled.div`
  position: relative;
  z-index: 1000;
`;

export { DrawerElement };
